import React from "react";

// export {default as UserLayout} from './User/index.layout';
// export {default as UserPublicLayout} from './User/public.layout';
// export {default as UserPrivateLayout} from './User/private.layout';
export const UserLayout = React.lazy(() => import("./User/index.layout"));
export const UserPublicLayout = React.lazy(() => import("./User/public.layout"));
export const UserPrivateLayout = React.lazy(() => import("./User/private.layout"));
